import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ai-license-popup',
  templateUrl: './ai-license-popup.component.html',
  styleUrls: ['./ai-license-popup.component.scss']
})
export class AiLicensePopupComponent {

  @Input() title!: string;
  @Input() content!: string;

  accepted = false;
  showRejectWarning = false;

  constructor(public activeModal: NgbActiveModal) {}

  onAccept() {
    if (!this.accepted) return;
    this.activeModal.close('ACCEPTED');
  }

  onReject() {
    if (!this.showRejectWarning) {
      this.showRejectWarning = true;
      return;
    }
    this.activeModal.close('REJECTED');
  }

  // close() {
  //   this.activeModal.dismiss('CANCEL');
  // }

  closeModal(){
         this.activeModal.close('CANCELLED');
    }
}
